<template>
         <a-card title="Meeting Recordings" :bordered="false" style="width: auto">
            <table class="table"  v-if="has_record">
                <tr>
                    <th>Type</th>
                    <th>File Type</th>
                    <th>Play</th>
                    <th>Download</th>
                </tr>
                <tbody>
                <tr  v-for="item in recordings" :key="item.id">
                    <td>{{item.recording_type}}</td>
                    <td>{{item.file_type}}</td>
                    <td><a :href="item.play_url">Play</a></td>
                    <td><a :href="item.download_url">Download</a> </td>
                </tr>
                </tbody>
               
            </table>
             <a-empty v-else>  <span slot="description"> {{recording_message}} </span></a-empty>
         </a-card>
</template>

<script>
import API from '../../services/api';
export default {
  data() {
    return {
      meeting_id: this.$route.params.id,
      recordings:[],
      visible: false,
      has_record: false,
      recording_message: 'No Records'
    };
  },
  created() {
    this.getRecordings()
  },
  methods: {
    getRecordings(){
      API.get(`/meetings/${this.meeting_id}/recordings`)
      .then(response => {
            if(response.status === 200){
              console.log(response.data)
              this.recordings = response.data.recording_files
              this.has_record = true
            }
            if(response.status === 302){
              this.recording_message = response.data.message
            }
      })
    }
  }
};
</script>